module.exports = __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmWUlfBBc4AMP6lQ.0b81348c.woff2";